"use strict";

angular.module("customer")
.controller("SectionLogin", function(
    $scope, $state, $rootScope, $stateParams, PartnershipService, FlashBag, UserService, GroupService, Language,
    IS_MOBILE_APP
) {
    Language.initializeScope($scope, "language", null);
    $scope.groupInvite = $stateParams.groupInvite || null;

    $scope.isMobileApp = IS_MOBILE_APP;

    //Watch for logged in status change
    $scope.$on("UserUpdated", function() {
        if (UserService.isLoggedIn()) {
            if ($stateParams.vendor || $stateParams.catalog || $stateParams.product) {
                $state.go("stocks", {
                    vendorId: $stateParams.vendor,
                    catalog: $stateParams.catalog,
                    product: $stateParams.product
                });
            }
            else if ($stateParams.vendorInvite) {
                PartnershipService.add({"vendorInvite": $stateParams.vendorInvite}).then(
                    function success(data) {
                        FlashBag.success(data.detail, true);
                    },
                    function failed(response) {
                        FlashBag.apiError(response, true);
                    }
                );
                $state.go("home");
            }
            else if ($scope.groupInvite) {
                GroupService.addCustomerGroupMembershipFromLogin($scope.groupInvite);
            }
            else if ($stateParams.invoice) {
                $state.go("invoiceDetails", {id: $stateParams.invoice});
            }
            else if ($stateParams.payment) {
                $state.go("paymentDetails", {id: $stateParams.payment});
            }
            else if ($stateParams.unpaid_invoices) {
                $state.go("payment", {selected: $stateParams.unpaid_invoices});
            }
            else if ($rootScope.toState && $rootScope.toState.name) {
                $state.go($rootScope.toState, $rootScope.toParams || {});
                $rootScope.toState = undefined;
                $rootScope.toParams = undefined;
            }
            else {
                $state.go("home");
            }
        }
    });

    $scope.$on("UserWithoutCustomerUpdated", function(event, user) {
        if (UserService.isLoggedIn()) {
            var route = "customer-listing";
            if (user.global_dedicated_vendor_id) {
                route = "partnership-listing";
            }

            $state.go(route, {
                vendorInvite: $stateParams.vendorInvite,
                groupInvite: $scope.groupInvite,
                vendor: $stateParams.vendor,
                catalog: $stateParams.catalog,
                product: $stateParams.product,
                invoice: $stateParams.invoice,
                payment: $stateParams.payment,
                unpaid_invoices: $stateParams.unpaid_invoices
            });
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/auth/login.controller.js
// module id = 895
// module chunks = 0